import { RadioGroupItem } from '@/components/ui/radio-group';
import { ColumnDef } from '@tanstack/react-table';
import { EditableCircuit } from '../circuits/EditableCircuitsColumnDef';
import { Translator } from '../translator.type';

export type CircuitForEstimateCreation = {
  circuit: {
    id: string;
    code: number;
    name: string;
    countries: string[];
    durationDays: number;
    durationNights: number;
  };
};

export const CIRCUIT_FOR_ESTIMATE_CREATION_COLUMNS = (
  t: Translator,
): ColumnDef<CircuitForEstimateCreation>[] => [
  {
    id: 'select',
    header: () => null,
    cell: ({ row }) => <RadioGroupItem value={row.original.circuit.id} />,
  },
  {
    accessorKey: 'circuit.code',
    header: t('distributorCircuits.list.editableCircuits.columns.code'),
    cell: ({ row }) => (
      <span>{`C${row.original.circuit.code.toString().padStart(4, '0')}`}</span>
    ),
  },
  {
    accessorKey: 'circuit.name',
    header: t('distributorCircuits.list.editableCircuits.columns.name'),
  },
  {
    accessorKey: 'circuit.countries',
    header: t('distributorCircuits.list.editableCircuits.columns.countries'),
    cell: ({ row }) => <span>{row.original.circuit.countries.join(', ')}</span>,
  },
  {
    accessorKey: 'circuit.durationDays',
    header: t('distributorCircuits.list.editableCircuits.columns.durationDays'),
    cell: ({ row }) =>
      row.original.circuit.durationDays ? (
        <span>
          {row.original.circuit.durationDays}j
          {row.original.circuit.durationNights &&
            ` / ${row.original.circuit.durationNights}n`}
        </span>
      ) : null,
  },
];

export const EDITABLE_CIRCUIT_FOR_ESTIMATE_CREATION_COLUMNS = (
  t: Translator,
): ColumnDef<EditableCircuit>[] => [
  {
    id: 'select',
    header: () => null,
    cell: ({ row }) => <RadioGroupItem value={row.original.id} />,
  },
  {
    accessorKey: 'code',
    header: t('distributorCircuits.list.editableCircuits.columns.code'),
    cell: ({ row }) => (
      <span>{`C${row.original.originalCircuit.code.toString().padStart(4, '0')}-${row.original.version}`}</span>
    ),
  },
  {
    accessorKey: 'name',
    header: t('distributorCircuits.list.editableCircuits.columns.name'),
    cell: ({ row }) => <span>{row.original.title ?? row.original.name}</span>,
  },
  {
    accessorKey: 'countries',
    header: t('distributorCircuits.list.editableCircuits.columns.countries'),
    cell: ({ row }) => <span>{row.original.countries.join(', ')}</span>,
  },
  {
    accessorKey: 'durationDays',
    header: t('distributorCircuits.list.editableCircuits.columns.durationDays'),
    cell: ({ row }) =>
      row.original.durationDays ? (
        <span>
          {row.original.durationDays}j
          {row.original.durationNights && ` / ${row.original.durationNights}n`}
        </span>
      ) : null,
  },
];
